module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_40.224a423c.jpg";